<template>
  <ul>
    <li v-for="category in categories" :key="category.id"
      class="list01-item is-parent is-open">
      <div class="label">
        <div class="formparts checkbox">
          <input type="checkbox"
            :value="category.id"
            :id="'cat_' + category.id"
            :checked="isChecked(category.id)"
            @change="check.changeCheck">
          <label role="button" :for="'cat_' + category.id">
            <span v-html="category.name"></span>
            <span v-if="showCount">({{category.search_count}})</span>
            <FontawesomeIcon icon="check" class="icn" />
          </label>
        </div>
      </div>
      <CheckBoxTree
        v-if="!category.name.startsWith('T&Amaster目次')"
        :categories="category.children"
        :checked="checked"
        :showCount="showCount"
        @checkSet="checkUpdate"
        />
    </li>
  </ul>
</template>

<script>
import { defineComponent } from '@vue/composition-api'
import CheckBoxTree from '@/components/pc/partial/CheckBoxTree.vue'
import { Checkbox } from '@/logic/common/Checkbox.js'

export default defineComponent({
  props: {
    showCount: {
      type: Boolean,
      default: false
    }
  },
  name: 'CheckBoxTree',
  components: {
    CheckBoxTree
  },
  setup (props, context) {
    return { ...Checkbox(props, context) }
  }
})
</script>
